 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import axios from "./../../config/socialaxios";

const apiGetProvinceList = async () => {
    try {
        const result = await axios.get(`/master-data/region/province`);
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _ => _.response, 'optionalAccess', _2 => _2.data]);
    }
};

const apiGetDistrictList = async (province_id) => {
    try {
        const result = await axios.get(
            `/master-data/region/district/${province_id}`
        );
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _3 => _3.response, 'optionalAccess', _4 => _4.data]);
    }
};

const apiGetSubDistrictList = async (province_id, district_id) => {
    try {
        const result = await axios.get(
            `/master-data/region/sub_district/${province_id}/${district_id}`
        );
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _5 => _5.response, 'optionalAccess', _6 => _6.data]);
    }
};

const apiGetTopicList = async (topic) => {
    try {
        const result = await axios.get(`/master-data/topic/${topic}`);
        return result;
    } catch (error) {
        return _optionalChain([error, 'optionalAccess', _7 => _7.response, 'optionalAccess', _8 => _8.data]);
    }
};

export {
    apiGetProvinceList,
    apiGetDistrictList,
    apiGetSubDistrictList,
    apiGetTopicList,
};